import clockSvg from "../../assets/Icon/Clock.svg";
import clipboardSvg from "../../assets/Icon/Clipboard.svg";
import calendarSvg from "../../assets/Icon/Calendar.svg";
import fileTextSvg from "../../assets/Icon/FileText.svg";
import shieldSvg from "../../assets/Icon/Shield.svg";
import editSvg from "../../assets/Icon/Edit.svg";
import { getLink } from "../../constants/links";

// クリニック共通メニュー項目（/clinic/* ページ用）
// 既存ルートの href を設定しています。未定義の画面は href を後日追加予定。
export const clinicMenuItems = [
  { label: "予約一覧", iconSrc: clockSvg, href: "/clinic/reservation-list" },
  { label: "患者様名簿", iconSrc: clipboardSvg, href: "/clinic/patient-list" },
  {
    label: "診療予約枠",
    iconSrc: calendarSvg,
    href: "/clinic/reservation-slots",
  },
  { label: "請求情報", iconSrc: fileTextSvg, href: "/clinic/invoice-list" },
  { label: "基本設定", iconSrc: editSvg, href: "/clinic/basic-info" },
  {
    label: "パスワード変更",
    iconSrc: editSvg,
    href: "/clinic/password-change",
  },
  {
    label: "利用規約",
    iconSrc: fileTextSvg,
    href: getLink("TERMS_OF_USE_PDF_FOR_CLINIC"),
  },
  {
    label: "プライバシーポリシー",
    iconSrc: shieldSvg,
    href: getLink("PRIVACY_POLICY"),
  },
];
